import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  CalibrationInformation,
  CertificateType,
  LoadcellInformationResponse,
} from "app/api/models";
import { EmailService } from "app/api/services";
import { ok } from "assert";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { sendEmailPDF } from "app/views/calibrations/shared/helpers/email-sending-helper";
import { AppLoaderService } from "app/core/services/app-loader/app-loader.service";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxPrintModule } from "ngx-print";

@Component({
  selector: "app-print-pressure-test-certificate-email-dialog",
  templateUrl: "./print-pressure-test-certificate-email-dialog.component.html",
  styleUrls: ["./print-pressure-test-certificate-email-dialog.component.scss", "./../../../../_styles/calibration-overrides.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FlexLayoutModule,
    DragScrollModule,
    NgxPrintModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
  ]
})
export class PrintPressureTestCertificateEmailDialogComponent
  implements OnInit
{
  Math = Math;

  calibration: CalibrationInformation;
  loadcell: LoadcellInformationResponse;

  pressureTestCerificateEmailFormGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PrintPressureTestCertificateEmailDialogComponent>,
    private emailService: EmailService,
    private loader: AppLoaderService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data != null) {
      this.loadcell = this.data.loadcellInfo;
    }
    this.createFormControls();
  }

  public cancelEmailPDF(): void {
    this.dialogRef.close();
  }

  sendEmailPDF() {
    if (this.pressureTestCerificateEmailFormGroup.valid) {
      var blob = this.data.blobPDFCertificate;

      this.loader.open;
      sendEmailPDF(
        this.emailService,
        this.pressureTestCerificateEmailFormGroup,
        this.loader,
        this.snack,
        blob,
        CertificateType.PressureTest,
        this.loadcell.loadcell.loadcellId,
      );
    }
  }

  createFormControls() {
    this.pressureTestCerificateEmailFormGroup = this.fb.group({
      emailToAddress: [
        this.data.loadcellInfo.contactEmail,
        Validators.required,
      ],
      subjectOfEmail: ["Pressure Test Certificate", Validators.required],
      emailBody: [
        `Good Morning/Afternoon ${this.data.loadcellInfo.contactName},\n\nThank you for sending your equipment to DLM for inspection and calibration.\n\nPlease see attached a copy of the certificate of pressure test.\nI will send copy documents once prepared.\nInvoice to follow.\n\nAlternatively you are welcome to arrange your own collection of the equipment, no carriage fee will apply.\nThe calibration is complete and you are welcome to collect any time. We are open 5 days a week, Mon – Fri, 8.30 – 5.00pm. Please send details of the collection and any labels you would like put on the package.\nYou will receive notification of the shipment and confirmation following delivery.\n\nconfirm once payment has been completed. Please complete payment via BACS or online banking. We can then proceed and arrange dispatch on receipt of payment.\nIf possible please send a copy of your remittance.\n\nBest Regards,\nTeam DLM`,
        Validators.required,
      ],
    });
  }
}
